import React from 'react'
import UnderDevelopment from '../components/UnderDevelopment/UnderDevelopment'

const Reports = () => {
  return (
    <UnderDevelopment />
  )
}

export default Reports